<template>
  <hr class="horizontal" style="margin: 8px 0" />

  <div class="d-flex-column justify-start align-start gap-10">
    <DesireRankPicker
      :item-key="'currentRank'"
      :title="$t('calculators_common.current_rank')"
      :tooltip="'current_rank_description'"
    />
    <hr class="horizontal" style="margin: 8px 0" />

    <!-- GALACTIC GUN -->
    <div class="d-flex-column justify-start align-start gap-5">
      <div class="d-flex-row justify-start gap-5">
        <label for="" class="t-light regular-l font-family-2">{{
          $t("calculators_common.number_of_galactic_guns")
        }}</label>
        <ItemTooltip
          :text="$t('calculators_common.select_number_of_galactic_guns')"
        />
      </div>
      <DropDown
        :drop-items="numberOfGuns"
        :selected-item="checkoutStore.getDetails.numberOfGalacticGuns"
        :select-drop-item="selectGun"
      />
    </div>
    <!-- <PointsPicker
      :title="$t('calculators_common.number_of_galactic_guns')"
      :description="$t('calculators_common.select_number_of_galactic_guns')"
      item-key="numberOfGalacticGuns"
      :step="1"
      :steps="steps2"
      :min="1"
      :max="5"
    /> -->
    <Checkbox
      :is-checked="haveCompetitivePoints"
      type="competitive"
      variant="secondary"
      :emit-function="toggleCompetitive"
      :label="$t('have_some_competitive_points')"
    />

    <Transition name="opace">
      <PointsPicker
        v-if="haveCompetitivePoints"
        :title="$t('calculators_common.number_of_points')"
        :description="$t('calculators_common.select_number_of_points')"
        item-key="numberOfPoints"
        :step="1"
        :steps="[]"
        :min="1"
        :max="2999"
      />
    </Transition>

    <hr class="horizontal" style="margin: 8px 0" />
    <ExtraOptionMin />
    <hr class="horizontal" style="margin: 8px 0" />
    <PlatformSelector />
    <DropHeroPicker />
    <hr class="horizontal" style="margin: 8px 0" />
    <CartOptionPicker />
    <hr class="horizontal" style="margin: 8px 0" />
    <RoleSelector />
  </div>
</template>

<script setup>
import DesireRankPicker from "../../fc-25/pickers/DesireRankPicker.vue";
import Checkbox from "~/components/custom/Checkbox.vue";
import CartOptionPicker from "./CartOptionPicker.vue";
import PointsPicker from "./PointsPicker.vue";
import PlatformSelector from "../../fc-25/pickers/PlatformSelector.vue";
import RoleSelector from "./RoleSelector.vue";
import ExtraOptionMin from "./ExtraOptionMin.vue";
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";
import DropHeroPicker from "./DropHeroPicker.vue";
import DropDown from "~/components/custom/DropDown.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const { t } = useI18n();
const steps = [
  {
    title: "1",
  },
  {
    title: "1500",
  },
  {
    title: "2999",
  },
];
const steps2 = [
  {
    title: "1",
  },
  {
    title: "2",
  },
  {
    title: "3",
  },
  {
    title: "4",
  },
  {
    title: "5",
  },
];

const numberOfGuns = ref({
  1: `1 ${t("calculators_common.galactic_guns")}`,
  2: `2 ${t("calculators_common.number_of_galactic_guns")}`,
  3: `3 ${t("calculators_common.number_of_galactic_guns")}`,
  4: `4 ${t("calculators_common.number_of_galactic_guns")}`,
  5: `5 ${t("calculators_common.number_of_galactic_guns")}`,
});

const selectGun = (key, value) => {
  checkoutStore.setDetails({
    ...checkoutStore.getDetails,
    numberOfGalacticGuns: parseInt(value),
  });
};

const handleDetails = () => {
  const rank = [...gameStore.getGameRanks].slice(1)[0];
  checkoutStore.clearCheckout();

  checkoutStore.setServer("52");
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentRank: {
      id: rank.id,
      title: rank.title,
    },
    numberOfGalacticGuns: 1,
  });

  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};
handleDetails();

const haveCompetitivePoints = ref(false);

const toggleCompetitive = () => {
  haveCompetitivePoints.value = !haveCompetitivePoints.value;
};

watch(haveCompetitivePoints, (newVal) => {
  if (!newVal) {
    delete checkoutStore.details?.numberOfPoints;
  } else {
    checkoutStore.setDetails({
      ...checkoutStore.getDetails,
      numberOfPoints: 1,
    });
  }
});

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
